import d17SVG from '../img/d17.svg';
import flouciSVG from '../img/flouci.svg';

const paymentMethods = [
  // {
  //   key: 'flouci',
  //   name: 'Flouci payment',
  //   value: 'flouci',
  //   img: flouciSVG,
  // },
  {
    key: 'd17',
    name: 'D17 payment',
    value: 'paykassma',
    img: d17SVG,
  },
];



export { paymentMethods };